import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'
import { useNavigate } from 'react-router-dom'

import logo from 'images/clients/header/logo.png'
import { API } from '../../../../javascripts/api'
import Icon from '../../../../../assets/images/clients/header/outbound_icon_black.svg'

const ClientHeader: React.FC = CSSModules<React.FC>(() => {
  const navigate = useNavigate()
  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()
    void API.clientLogout().
      then(response => {
        if (response.status === 200) navigate('/client_auth/login', {
          state: {
            flash: { success: response.data.message },
          },
        })
      })
  }

  return (
    <header styleName='client-header' className='client-header'>
      <div styleName='header'>
        <a styleName='logo' href='/'>
          <img src={logo} alt='クラウドワークス エージェント' />
        </a>
        <div styleName='link'>
          <a href='/client_auth/logout' onClick={handleLogout}>ログアウト</a>
        </div>
      </div>
      <div styleName='redirect'>
        <a href='https://forms.gle/vrhpjzY82c18fheV7' target='_blank' className="flex items-center">お問い合わせ<img src={Icon} alt='' styleName='outbound'/></a>
      </div>
    </header>
  )
}, styles)

export default ClientHeader
